export default class Urlfilters {
  constructor(selectedCategories = '') {
    this.selectedCategories = selectedCategories.toString();
  }

  getSelectedCategories() {
    return this.selectedCategories;
  }

  getSelectedCategory() {
    return this.selectedCategories.split(',')[0];
  }
}
